var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"playWndBox",staticClass:"videoMain",attrs:{"id":"videoMain"}},[_c('div',{ref:"playWnd",staticClass:"playWnd",attrs:{"id":"playWnd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }